import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import TaxonAction from 'referencial/components/taxon/actions/TaxonAction'
import useBoolean from 'utils/customHook/useBoolean'
import { isNil } from 'lodash'
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, Icon, Tooltip } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { NewTable } from 'components/datatable/NewTable'
import OperationAction from 'quality/components/operation/actions/OperationAction'

const CalculateTaxons = ({
    operationIds = [],
    presentTaxons = [],
}) => {
    const dispatch = useDispatch()
    const {
        qualitometer,
        taxons,
    } = useSelector(store => ({
        qualitometer: store.QualityReducer.qualitometer,
        taxons: store.TaxonReducer.taxons,
    }), shallowEqual)

    const {
        value: isOpen,
        setTrue: open,
        setFalse: close,
    } = useBoolean(false)

    useEffect(() => {
        if (taxons.length === 0) dispatch(TaxonAction.fetchTaxons())
    }, [dispatch])

    const formattedTaxons = taxons.filter(t => t.calculate === '1' && t.calculTaxonCode && t.calculTaxonCode.split(/[;,]/).some(code => presentTaxons.includes(code))).map(p => ({
        code: p.code,
        name: p.latinName ?? p.code,
        nbTaxons: p.calculTaxonCode.split(/;|,/).length,
    }))

    const onCalculate = () => {
        if (operationIds.length === 0 || isNil(qualitometer.id)) return
        dispatch(OperationAction.calculateTaxons(qualitometer.id, operationIds))
    }

    return (
        <div className='action-wrapper'>
            <Tooltip title={i18n.calculTaxons} placement='bottom'>
                <Icon
                    sx={{ fontSize: '3rem', width: '69px', height: '64px', paddingTop: '12px', cursor: 'pointer' }}
                    onClick={open}
                >compost</Icon>
            </Tooltip>
            <Dialog
                maxWidth='md'
                fullWidth
                open={isOpen}
                slotProps={{
                    paper: {
                        sx: {
                            minHeight: undefined,
                            maxHeight: undefined,
                        },
                    },
                }}
            >
                <DefaultDialogTitle title={i18n.calculTaxons} onClose={close} />
                <DialogContent>
                    {formattedTaxons.length === 0 && (<Card><CardContent><div className='center'> { i18n.noCalculateTaxons }</div></CardContent></Card>)}
                    {formattedTaxons.length > 0 && (
                        <NewTable
                            rows={formattedTaxons}
                            headers={['code', 'name', 'nbTaxons']}
                            maxHeight={275}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCalculate} variant='contained' color='primary' disabled={formattedTaxons.length === 0}>
                        {i18n.calculate}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

CalculateTaxons.propTypes = {
    operationIds: PropTypes.arrayOf(PropTypes.number),
    presentTaxons: PropTypes.arrayOf(PropTypes.string),
}

export default CalculateTaxons